module.exports = __webpack_public_path__ + "img/uj_09.609564b3.jpg";